import { useEffect } from 'react';
import { ASTRA_COLORS } from 'constants/routes';

const DEFAULT_SCROLLBAR_WIDTH = 'thin';
const DEFAULT_SCROLLBAR_COLOR = `${ASTRA_COLORS.BRIGHT_PRODUCT} transparent`;

interface IUseScrollbarOptions {
  scrollbarColor: string;
  scrollbarWidth: string;
  useEffectDeps: any[];
}

export const useBrowserScrollbarStyle = (
  element: HTMLElement | null = document.documentElement,
  options: IUseScrollbarOptions = {
    scrollbarColor: DEFAULT_SCROLLBAR_COLOR,
    scrollbarWidth: DEFAULT_SCROLLBAR_WIDTH,
    useEffectDeps: [],
  }
) => {
  // This is requred because setting scrollbarColor or scrollbarWidth disables webkit scrollbar styles for chrome
  return useEffect(() => {
    const isNotChrome = !navigator.userAgent.toLowerCase().includes('chrome');
    if (isNotChrome && element) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      element.style.scrollbarColor = options.scrollbarColor;
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      element.style.scrollbarWidth = options.scrollbarWidth;
    }
  }, options.useEffectDeps);
};
